import React, {
  useState,
  useContext,
  useRef,
  useEffect,
  Fragment,
} from 'react';
import { Link, Redirect } from 'react-router-dom';
import { store } from '../../store';
import axios from '../../api/axios';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Circular from '../../components/Progress/Circular';
import Skeleton from '@material-ui/lab/Skeleton';
import { useHistory } from 'react-router-dom';
import useTitle from 'hooks/useTitle';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  title: {
    marginTop: theme.spacing(2),
    textAlign: 'center',
  },
  center: {
    textAlign: 'center',
  },
}));

const Login = () => {
  useTitle('ورود');
  const classes = useStyles();
  const { state, dispatch, showMessage, showError } = useContext(store);
  const {
    Public: { appName, appLogo },
    Auth: { logged },
  } = state;
  const [fields, setFields] = useState({ username: '', password: '' });
  const [isLoaded, setIsLoaded] = useState(true);
  const usernameField = useRef(null);
  const referUrl = localStorage.getItem('referUrl');
  const history = useHistory();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFields({ ...fields, [name]: value });
  };
  const checkUser = async (username, password) => {
    try {
      let { data } = await axios.post(`/auth/user/login`, {
        username,
        password,
      });
      if (data?.refreshToken) {
        const { accessToken, refreshToken } = data;
        localStorage.setItem('@footab/admin/accessToken', accessToken);
        localStorage.setItem('@footab/admin/refreshToken', refreshToken);
      }
      if (data?.ok && data?.hasTwoWayAuth) {
        sessionStorage.setItem('userId', data.userId);
        sessionStorage.setItem('expireTime', Date.now() + 60000);
        history.push('/verify');
      } else if (data.ok)
        dispatch({ type: 'AUTH', payload: true, action: 'LOGIN' });
      else {
        throw data;
      }
    } catch (err) {
      showError(err);
      setIsLoaded(true);
      setFields({ username: '', password: '' });
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoaded(false);
    const { username, password } = fields;
    checkUser(username, password);
  };
  const loadPublicSettings = async () => {
    const { data } = await axios.get('/api/v1/admin/setting/public');
    data && dispatch({ type: 'PUBLIC', payload: data, action: 'SET' });
  };
  const checkAuth = async () => {
    try {
      const { data } = await axios.get(`/auth/user/auth`);
      if (data.ok) {
        dispatch({ type: 'AUTH', payload: true, action: 'LOGIN' });
      } else {
        dispatch({ type: 'AUTH', payload: false, action: 'LOGIN' });
      }
    } catch (error) {
      dispatch({ type: 'AUTH', action: 'LOGOUT' });
      showError(error);
    }
  };

  useEffect(() => {
    checkAuth();
  }, []);
  useEffect(() => {
    logged === false && usernameField.current.focus();
  }, [logged]);

  return (
    <Fragment>
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justify="center"
        style={{ minHeight: '100vh' }}
      >
        <Container maxWidth="sm">
          <form
            onSubmit={handleSubmit}
            onKeyPress={(e) => {
              e.key === 'Enter' && handleSubmit(e);
            }}
          >
            <Paper>
              <Grid
                container
                direction="column"
                justify="center"
                alignItems="stretch"
                className={classes.root}
                spacing={2}
              >
                {logged === false && (
                  <Fragment>
                    <Grid item className={classes.title}>
                      <Link to="/login">
                        {appLogo ? (
                          <img
                            src={appLogo}
                            height="100"
                            alt="لوگو {appName}"
                          />
                        ) : (
                          <Skeleton
                            variant="circle"
                            height={100}
                            width={100}
                            style={{ margin: '0 auto' }}
                          />
                        )}
                      </Link>
                      <Link to="/login">
                        {appName ? (
                          <h1>{appName}</h1>
                        ) : (
                          <Skeleton
                            variant="text"
                            width={200}
                            height={40}
                            style={{ margin: '0 auto' }}
                          />
                        )}
                      </Link>
                    </Grid>
                    <Grid item>
                      <TextField
                        label="نام کاربری"
                        variant="outlined"
                        fullWidth
                        name="username"
                        onChange={handleChange}
                        value={fields.username}
                        ref={usernameField}
                      />
                    </Grid>
                    <Grid item>
                      <TextField
                        label="گذرواژه"
                        variant="outlined"
                        fullWidth
                        name="password"
                        type="password"
                        onChange={handleChange}
                        value={fields.password}
                      />
                    </Grid>
                    <Grid item className={classes.center}>
                      <Button
                        variant="contained"
                        color="secondary"
                        size="large"
                        onClick={handleSubmit}
                        disabled={!isLoaded}
                        fullWidth
                      >
                        {isLoaded ? 'ورود' : 'صبر کنید ...'}
                      </Button>
                    </Grid>
                  </Fragment>
                )}
                {logged === null && <Circular />}
              </Grid>
            </Paper>
          </form>
        </Container>
      </Grid>

      {logged && <Redirect to={referUrl ? referUrl : '/protected'} />}
    </Fragment>
  );
};

export default React.memo(Login);
